import { defaultColours } from "./DefaultColours";

export const chartBlocks = [
	{
		type: "row",
		x: {
			value: 322.5,
			unit: "POINT"
		},
		y: {
			value: 428.75,
			unit: "POINT"
		},
		width: {
			value: 222.5,
			unit: "POINT"
		},
		height: {
			value: 20.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: null,
		loop: null,
		filter: null,
		columnSizes: [25.0, 137.5, 30.0, 30.0],
		cells: [
			null,
			{
				type: "text",
				x: {
					value: 0.0,
					unit: "POINT"
				},
				y: {
					value: 0.0,
					unit: "POINT"
				},
				width: {
					value: 137.5,
					unit: "POINT"
				},
				height: {
					value: 20.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "static",
					text: "Score"
				},
				font: "liberationsans-bold",
				fontSize: 11.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "LEFT",
				valign: "TOP"
			},
			{
				type: "text",
				x: {
					value: 0.0,
					unit: "POINT"
				},
				y: {
					value: 0.0,
					unit: "POINT"
				},
				width: {
					value: 30.0,
					unit: "POINT"
				},
				height: {
					value: 20.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "static",
					text: "#"
				},
				font: "liberationsans-bold",
				fontSize: 11.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "RIGHT",
				valign: "TOP"
			},
			{
				type: "text",
				x: {
					value: 0.0,
					unit: "POINT"
				},
				y: {
					value: 0.0,
					unit: "POINT"
				},
				width: {
					value: 30.0,
					unit: "POINT"
				},
				height: {
					value: 20.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "static",
					text: "%"
				},
				font: "liberationsans-bold",
				fontSize: 11.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "RIGHT",
				valign: "TOP"
			}
		]
	},
	{
		type: "row",
		x: {
			value: 322.5,
			unit: "POINT"
		},
		y: {
			value: 448.75,
			unit: "POINT"
		},
		width: {
			value: 222.5,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: null,
		loop: {
			type: "field",
			jsonPath: "$.evaluation.scoreNames"
		},
		filter: null,
		columnSizes: [25.0, 137.5, 30.0, 30.0],
		cells: [
			{
				type: "composite",
				x: {
					value: 0.0,
					unit: "POINT"
				},
				y: {
					value: 0.0,
					unit: "POINT"
				},
				width: {
					value: 15.0,
					unit: "POINT"
				},
				height: {
					value: 15.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				blocks: [
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: {
							type: "function",
							function: "eq",
							arguments: [
								{
									type: "dynamic",
									expression: "{index}"
								},
								{
									type: "static",
									text: "0"
								}
							]
						},
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: defaultColours[0]
					},
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: {
							type: "function",
							function: "eq",
							arguments: [
								{
									type: "dynamic",
									expression: "{index}"
								},
								{
									type: "static",
									text: "1"
								}
							]
						},
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: defaultColours[1]
					},
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: {
							type: "function",
							function: "eq",
							arguments: [
								{
									type: "dynamic",
									expression: "{index}"
								},
								{
									type: "static",
									text: "2"
								}
							]
						},
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: defaultColours[2]
					},
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: {
							type: "function",
							function: "eq",
							arguments: [
								{
									type: "dynamic",
									expression: "{index}"
								},
								{
									type: "static",
									text: "3"
								}
							]
						},
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: defaultColours[3]
					},
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: {
							type: "function",
							function: "eq",
							arguments: [
								{
									type: "dynamic",
									expression: "{index}"
								},
								{
									type: "static",
									text: "4"
								}
							]
						},
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: defaultColours[4]
					},
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: {
							type: "function",
							function: "eq",
							arguments: [
								{
									type: "dynamic",
									expression: "{index}"
								},
								{
									type: "static",
									text: "5"
								}
							]
						},
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: defaultColours[5]
					},
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: {
							type: "function",
							function: "eq",
							arguments: [
								{
									type: "dynamic",
									expression: "{index}"
								},
								{
									type: "static",
									text: "6"
								}
							]
						},
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: defaultColours[6]
					},
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: {
							type: "function",
							function: "eq",
							arguments: [
								{
									type: "dynamic",
									expression: "{index}"
								},
								{
									type: "static",
									text: "7"
								}
							]
						},
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: defaultColours[7]
					},
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: {
							type: "function",
							function: "eq",
							arguments: [
								{
									type: "dynamic",
									expression: "{index}"
								},
								{
									type: "static",
									text: "8"
								}
							]
						},
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: defaultColours[8]
					},
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: {
							type: "function",
							function: "eq",
							arguments: [
								{
									type: "dynamic",
									expression: "{index}"
								},
								{
									type: "static",
									text: "9"
								}
							]
						},
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: defaultColours[9]
					}
				]
			},
			{
				type: "text",
				x: {
					value: 0.0,
					unit: "POINT"
				},
				y: {
					value: 0.0,
					unit: "POINT"
				},
				width: {
					value: 137.0,
					unit: "POINT"
				},
				height: {
					value: 15.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "field",
					jsonPath: "#"
				},
				font: "liberationsans-regular",
				fontSize: 10.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "LEFT",
				valign: "MIDDLE"
			},
			{
				type: "text",
				x: {
					value: 0.0,
					unit: "POINT"
				},
				y: {
					value: 0.0,
					unit: "POINT"
				},
				width: {
					value: 30.0,
					unit: "POINT"
				},
				height: {
					value: 15.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "function",
					function: "count",
					arguments: [
						{
							type: "function",
							function: "matches",
							arguments: [
								{
									type: "field",
									jsonPath:
										"$.evaluation.criteria[*].subsections[*].subsections[*].latestProperties..score"
								},
								{
									type: "function",
									function: "int",
									arguments: [
										{
											type: "function",
											function: "+",
											arguments: [
												{
													type: "dynamic",
													expression: "{index}"
												},
												{
													type: "function",
													function: "int",
													arguments: [
														{
															type: "static",
															text: "1"
														}
													]
												}
											]
										}
									]
								}
							]
						}
					]
				},
				font: "liberationsans-regular",
				fontSize: 10.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "RIGHT",
				valign: "MIDDLE"
			},
			{
				type: "text",
				x: {
					value: 0.0,
					unit: "POINT"
				},
				y: {
					value: 0.0,
					unit: "POINT"
				},
				width: {
					value: 30.0,
					unit: "POINT"
				},
				height: {
					value: 15.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "function",
					function: "*",
					arguments: [
						{
							type: "function",
							function: "/",
							arguments: [
								{
									type: "function",
									function: "count",
									arguments: [
										{
											type: "function",
											function: "matches",
											arguments: [
												{
													type: "field",
													jsonPath:
														"$.evaluation.criteria[*].subsections[*].subsections[*].latestProperties..score"
												},
												{
													type: "function",
													function: "int",
													arguments: [
														{
															type: "function",
															function: "+",
															arguments: [
																{
																	type: "dynamic",
																	expression:
																		"{index}"
																},
																{
																	type: "function",
																	function:
																		"int",
																	arguments: [
																		{
																			type: "static",
																			text: "1"
																		}
																	]
																}
															]
														}
													]
												}
											]
										}
									]
								},
								{
									type: "function",
									function: "count",
									arguments: [
										{
											type: "field",
											jsonPath:
												"$.evaluation.criteria[*].subsections[*].subsections[*].latestProperties..[?(@.score)][?(@.score != '')]'"
										}
									]
								}
							]
						},
						{
							type: "static",
							text: "100"
						}
					]
				},
				font: "liberationsans-regular",
				fontSize: 10.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "RIGHT",
				valign: "MIDDLE"
			}
		]
	},
	{
		type: "chart",
		x: {
			value: 50.0,
			unit: "POINT"
		},
		y: {
			value: 375.0,
			unit: "POINT"
		},
		width: {
			value: 222.5,
			unit: "POINT"
		},
		height: {
			value: 222.5,
			unit: "POINT"
		},
		absolutePosition: true,
		condition: null,
		loop: null,
		filter: null,
		chartType: "PIE",
		series: [
			{
				type: "loop",
				loopFunction: {
					type: "field",
					jsonPath: "$.evaluation.scoreNames"
				},
				valueFunction: {
					type: "function",
					function: "*",
					arguments: [
						{
							type: "function",
							function: "/",
							arguments: [
								{
									type: "function",
									function: "count",
									arguments: [
										{
											type: "function",
											function: "matches",
											arguments: [
												{
													type: "field",
													jsonPath:
														"$.evaluation.criteria[*].subsections[*].subsections[*].latestProperties..score"
												},
												{
													type: "function",
													function: "int",
													arguments: [
														{
															type: "function",
															function: "+",
															arguments: [
																{
																	type: "dynamic",
																	expression:
																		"{index}"
																},
																{
																	type: "function",
																	function:
																		"int",
																	arguments: [
																		{
																			type: "static",
																			text: "1"
																		}
																	]
																}
															]
														}
													]
												}
											]
										}
									]
								},
								{
									type: "function",
									function: "count",
									arguments: [
										{
											type: "field",
											jsonPath:
												"$.evaluation.criteria[*].subsections[*].subsections[*].latestProperties..[?(@.score)][?(@.score != '')]'"
										}
									]
								}
							]
						},
						{
							type: "static",
							text: "100"
						}
					]
				},
				colors: defaultColours
			}
		],
		font: "liberationsans-regular",
		fontSize: 8.0,
		fontColor: [0.0, 0.0, 0.0]
	}
];
